import { identity } from 'lodash';
import { needsRedact } from '@ardoq/perspectives';
import type { CommandRejection } from './types';

export type ShowName = (name: string) => string;

export type ValidationRejection = {
  kind: string;
  buildReason: (showName: ShowName) => string;
};

export const staticRejection = (
  kind: string,
  reason: string
): ValidationRejection => ({ kind, buildReason: () => reason });

export const toCommandRejection = ({
  kind,
  buildReason,
}: ValidationRejection): CommandRejection => ({
  status: 'rejected',
  reason: buildReason(identity),
  validationFailure: { kind, redactedReason: buildReason(needsRedact) },
});
